module.exports = __webpack_public_path__ + "img/z.de6a6de3.png";